import React from 'react';
import { constants } from '@clubmed/utils';
import { t } from 'Src/i18n';
const { FLEX_RATES } = constants;
type Props = {
  price: ProposalPrice;
};

const getLabel = ({ selectedRate }) => {
  switch (selectedRate) {
    case FLEX_RATES.NRR:
      return t('booking.accommodation.stickyPrice.nonRefundableRateLabel');

    case FLEX_RATES.FLR:
      return t('booking.accommodation.packageContent.flexibleRateLabel');

    default:
      return t('booking.accommodation.packageContent.standardLabel');
  }
};

export const SelectedRate = ({ price }: Props) => (
  <span
    className="block whitespace-nowrap text-center text-12 font-bold leading-1 text-white"
    data-testid="selected-rate-content"
  >
    {getLabel(price)}
  </span>
);
